import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getFilterAmcred() {
  try {
    const response = yield call(api.getFilterAmcred);

    yield put(Creators.getFilterAmcredSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getFilterAmcredFailure());
  }
}
